/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetCashtagSuggestionRequest} from '@cash-web/protos/squareup/franklin/app/cashtag.pb'
import {GetCashtagSuggestionResponse} from '@cash-web/protos/squareup/franklin/app/cashtag.pb'


export const getCashtagSuggestion = (request:GetCashtagSuggestionRequest, options?: CashRequestOptions) => post<GetCashtagSuggestionRequest, GetCashtagSuggestionResponse>("/2.0/cash/get-cashtag-suggestion", request, {...options, rejectOnError: true })